export const enum StatsEntityEnum {
  agent = 'agent',
  broker = 'broker',
  property = 'property',
  project = 'project',
}
